import type { IColumnDefinition } from './types';

export function normalizeColumn(col: IColumnDefinition): IColumnDefinition {
  const field = col.field || col.name;
  const type = col.type || 'text';
  const systemColumn = col.systemColumn || false;

  return {
    ...col,
    field,
    type,
    systemColumn,
    header: col.header ?? col.name,
    sortable: systemColumn ? false : (col.sortable ?? true),
    sort: col.sort ?? 0,
    resizable: systemColumn ? false : (col.resizable ?? true),
    editable: col.editable ?? true,
    readonly: col.readonly ?? false,
    required: col.required ?? false,
  };
}

export function normalizeColumns(
  columns: IColumnDefinition[],
): IColumnDefinition[] {
  return columns.map(normalizeColumn);
}
